import { m as motion, useTransform } from 'framer-motion';
import React, { forwardRef } from 'react';
import useScrollProgress from '@polestar/component-warehouse-react/components/parallax/useScrollProgress';
import useCombinedRef from '@polestar/component-warehouse-react/hooks/useCombinedRef';
import styled from '@emotion/styled';
const Parallax = forwardRef(({ parallaxProp = 'y', parallaxIn = [0, 1], parallaxOut, children, style, ...props }, ref) => {
    const { scrollProgressRef, progress } = useScrollProgress();
    const transform = useTransform(progress, parallaxIn, parallaxOut);
    const combinedRef = useCombinedRef(ref, scrollProgressRef);
    return (React.createElement(ParallaxContainer, { key: parallaxProp, ref: combinedRef, ...props, style: { [parallaxProp]: transform, ...style } }, children));
});
Parallax.displayName = 'Parallax';
export default Parallax;
const ParallaxContainer = styled(motion.div) ``;
